
import React, { createContext, useContext, useState } from 'react';
import * as htmlToImage from 'html-to-image';

const FontContext = createContext();

export const useFont = () => {
  return useContext(FontContext);
};

export const FontProvider = ({ children }) => {
  const [fonte, setFonte] = useState('sans-serif');
  const [imagens, setImagens] = useState([]);

  const alterarFonte = (novaFonte) => {
    setFonte(novaFonte);
  };

  const adicionarImagem = (novaImagem) => {
    setImagens(novaImagem);
  };

  const handleDownloadImage = (containerId) => {
    const container = document.getElementById(containerId);

    if (!container) {
      console.error('Contêiner não encontrado');
      return;
    }

    htmlToImage.toPng(container)
      .then(function (dataUrl) {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'imagem.png'; // Nome do arquivo de download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function (error) {
        console.error('Oops, algo deu errado!', error);
      });
  };

  return (
    <FontContext.Provider value={{ fonte, alterarFonte, imagens, adicionarImagem, handleDownloadImage }}>
      {children}
    </FontContext.Provider>
  );
};



















/*
import React, { createContext, useContext, useState } from 'react';

const FontContext = createContext();

export const useFont = () => {
  return useContext(FontContext);
};

export const FontProvider = ({ children }) => {
  const [fonte, setFonte] = useState('sans-serif');
  const [imagens, setImagens] = useState([]);

  const alterarFonte = (novaFonte) => {
    setFonte(novaFonte);
  };

  const adicionarImagem = (novaImagem) => {
    setImagens(novaImagem);
  };

  return (
    <FontContext.Provider value={{ fonte, alterarFonte, imagens, adicionarImagem }}>
      {children}
    </FontContext.Provider>
  );
};
*/









/*
import React, { createContext, useContext, useState } from 'react';

const ImgContext = createContext();

export const useImg = () => {
  return useContext(ImgContext);
};

export const FontProvider = ({ children }) => {
  const [imgUsplash, setImgUsplash] = useState();

  const alterarImg = novaImg => {
    setImgUsplash(novaImg);
  };

  return (
    <ImgContext.Provider value={{ imgUsplash, alterarImg }}>
      {children}
    </ImgContext.Provider>
  );
};
*/